function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import Bulma from '../core';
import Plugin from '../plugin';
/**
 * @module Navbar
 * @since  0.1.0
 * @author  Thomas Erbe <vizuaalog@gmail.com>
 */

var Navbar = /*#__PURE__*/function (_Plugin) {
  _inherits(Navbar, _Plugin);

  var _super = _createSuper(Navbar);

  /**
   * Plugin constructor
   * @param  {Object} options The options object for this plugin
   * @return {this} The newly created plugin instance
   */
  function Navbar(options) {
    var _this;

    _classCallCheck(this, Navbar);

    _this = _super.call(this, options); // Work out the parent if it hasn't been supplied as an option.

    if (_this.parent === null) {
      _this.parent = _this.option('element').parentNode;
    }
    /**
     * The root navbar element.
     * @type {HTMLElement}
     */


    _this.element = _this.option('element');
    /**
     * The element used for the trigger.
     * @type {HTMLElement}
     */

    _this.trigger = _this.element.querySelector('.navbar-burger'),
    /**
     * The target element.
     * @type {HTMLELement}
     */
    _this.target = _this.element.querySelector('.navbar-menu');
    /**
     * Should this navbar stick to the top of the page?
     * @type {boolean}
     */

    _this.sticky = !!_this.option('sticky');
    /**
     * The offset in pixels before the navbar will stick to the top of the page
     * @type {number}
     */

    _this.stickyOffset = parseInt(_this.option('stickyOffset'));
    /**
     * Should the navbar hide when scrolling? Note: this just applies a 'is-hidden-scroll' class.
     * @type {boolean}
     */

    _this.hideOnScroll = !!_this.option('hideOnScroll');
    /**
     * The amount of tolerance required before checking the navbar should hide/show
     * @type {number}
     */

    _this.tolerance = parseInt(_this.option('tolerance'));
    /**
     * Add a shadow when the navbar is sticky?
     * @type {boolean}
     */

    _this.shadow = !!_this.option('shadow');
    /**
     * The offset in pixels before the navbar will be hidden, defaults to the height of the navbar
     * @type {number}
     */

    _this.hideOffset = parseInt(_this.option('hideOffset', Math.max(_this.element.scrollHeight, _this.stickyOffset)));
    /**
     * The last scroll Y known, this is used to calculate scroll direction
     * @type {number}
     */

    _this.lastScrollY = 0;

    _this.registerEvents();

    return _this;
  }
  /**
   * Register all the events this module needs.
   * @return {undefined}
   */


  _createClass(Navbar, [{
    key: "registerEvents",
    value: function registerEvents() {
      this.trigger.addEventListener('click', this.handleTriggerClick.bind(this));

      if (this.sticky) {
        window.addEventListener('scroll', this.handleScroll.bind(this));
      }
    }
    /**
     * Handle the click event on the trigger.
     * @return {undefined}
     */

  }, {
    key: "handleTriggerClick",
    value: function handleTriggerClick() {
      if (this.target.classList.contains('is-active')) {
        this.target.classList.remove('is-active');
        this.trigger.classList.remove('is-active');
      } else {
        this.target.classList.add('is-active');
        this.trigger.classList.add('is-active');
      }
    }
    /**
     * Handle the scroll event
     * @return {undefined}
     */

  }, {
    key: "handleScroll",
    value: function handleScroll() {
      this.toggleSticky(window.pageYOffset);
    }
    /**
     * Toggle the navbar's sticky state
     * @param {number} scrollY The amount of pixels that has been scrolled
     * @return {undefined}
     */

  }, {
    key: "toggleSticky",
    value: function toggleSticky(scrollY) {
      if (scrollY > this.stickyOffset) {
        this.element.classList.add('is-fixed-top');
        document.body.classList.add('has-navbar-fixed-top');

        if (this.shadow) {
          this.element.classList.add('has-shadow');
        }
      } else {
        this.element.classList.remove('is-fixed-top');
        document.body.classList.remove('has-navbar-fixed-top');

        if (this.shadow) {
          this.element.classList.remove('has-shadow');
        }
      }

      if (this.hideOnScroll) {
        var scrollDirection = this.calculateScrollDirection(scrollY, this.lastScrollY);
        var triggeredTolerance = this.difference(scrollY, this.lastScrollY) >= this.tolerance;

        if (scrollDirection === 'down') {
          // only hide the navbar at the top if we reach a certain offset so the hiding is more smooth
          var isBeyondTopOffset = scrollY > this.hideOffset;

          if (triggeredTolerance && isBeyondTopOffset) {
            this.element.classList.add('is-hidden-scroll');
          }
        } else {
          // if scrolling up to the very top where the navbar would be by default always show it
          var isAtVeryTop = scrollY < this.hideOffset;

          if (triggeredTolerance || isAtVeryTop) {
            this.element.classList.remove('is-hidden-scroll');
          }
        }

        this.lastScrollY = scrollY;
      }
    }
  }, {
    key: "difference",
    value: function difference(a, b) {
      if (a > b) {
        return a - b;
      } else {
        return b - a;
      }
    }
  }, {
    key: "calculateScrollDirection",
    value: function calculateScrollDirection(currentY, lastY) {
      return currentY >= lastY ? 'down' : 'up';
    }
  }], [{
    key: "getRootClass",
    value:
    /**
     * Returns a string containing the element class this plugin supports.
     * @returns {string} The class name.
     * @throws {Error} Thrown if this method has not been replaced.
     */
    function getRootClass() {
      return 'navbar';
    }
    /**
     * Handle parsing the DOMs data attribute API.
     * @param {HTMLElement} element The root element for this instance
     * @return {undefined}
     */

  }, {
    key: "parse",
    value: function parse(element) {
      new Navbar({
        element: element,
        sticky: element.hasAttribute('data-sticky') ? true : false,
        stickyOffset: element.hasAttribute('data-sticky-offset') ? element.getAttribute('data-sticky-offset') : 0,
        hideOnScroll: element.hasAttribute('data-hide-on-scroll') ? true : false,
        tolerance: element.hasAttribute('data-tolerance') ? element.getAttribute('data-tolerance') : 0,
        hideOffset: element.hasAttribute('data-hide-offset') ? element.getAttribute('data-hide-offset') : null,
        shadow: element.hasAttribute('data-sticky-shadow') ? true : false
      });
    }
    /**
     * Returns an object containing the default options for this plugin.
     * @returns {object} The default options object.
     */

  }, {
    key: "defaultOptions",
    value: function defaultOptions() {
      return {
        sticky: false,
        stickyOffset: 0,
        hideOnScroll: false,
        tolerance: 0,
        hideOffset: null,
        shadow: false
      };
    }
  }]);

  return Navbar;
}(Plugin);

Bulma.registerPlugin('navbar', Navbar);
export default Navbar;